import { BaseApi } from './base-api';
import { UpSell } from '../types/up-sell';
import { IResponsePadrao } from '../types/response-padrao';
import { mockIp } from '../mocks/mock-ip';
import { UpSellIntent } from '../types/up-sell-intent';
import { Sell } from '../types/venda';

export class UpSellApi extends BaseApi<UpSell> {
  constructor() {
    super('up-sell');
  }

  override async show(id: string): Promise<IResponsePadrao<UpSell>> {
    return (
      await this.api.get(`${this.path}/${id}`, {
        headers: {
          'x-forwarded-for': mockIp,
        },
      })
    ).data;
  }

  async intent(
    upsellId: string,
    vendaId: string,
  ): Promise<IResponsePadrao<UpSellIntent>> {
    return (
      await this.api.get(`${this.path}/intent`, {
        headers: {
          'x-forwarded-for': mockIp,
        },
        params: {
          upsellId,
          vendaId,
        },
      })
    ).data;
  }

  async confirm(
    id: string,
    recaptcha: string,
    extraBody?: any,
  ): Promise<IResponsePadrao<Sell>> {
    return (
      await this.api.post(`up-sell/confirm`, {
        id,
        recaptchaToken: recaptcha,
        payment: extraBody ?? undefined,
      })
    ).data;
  }
}
